import Vue from "vue";
import { customEvent } from "../../../modules/tracking/AnalyticsEvents";

const state = {
    loading: true,
    init: false,
    admin: false,
    adminName: 'Guest',
    compare: {
        used: [],
        new: [],
        motability: [],
    },
    login: {
        email: null,
        passsword: null,
    },
    brand: 'randd',
    usedCars: {},
    headerMenuLinks: {},
    usedRefineSearch: false,
    showSaveCompare: false,
    includeSocialMedia: false,
    showLiveChat: true,
    telephone: '024 7685 1458',
    reusableFAQs: {},
    siteLinksNewModels: [],
    siteLinksUsedVehicles: [],
    showSavedVehicleModal: 0,
    errors: null,
    statusMessage: null,
    saveAfterLoginVehicleData: {
        add: null,
        type: null,
        id: null,
    },
    accountVehicleActions: {
        displayPriceAlertModal:false,
        priceAlert:{},
        vehicleSaved:false,
    },
    savePriceAlertAfterRegister: {
        type: null,
        id: null,
    }
};

const getters = {
    compareCount(state) {
        return state.compare.used.length + state.compare.new.length + state.compare.motability.length;
    },
    compareLink(state) {
        if (state.compare.used.length >= state.compare.new.length) {
            return { name: 'saved-vehicles', params: { type: 'used' } };
        }
        return { name: 'saved-vehicles', params: { type: 'new' } };
    },
    brand(state) {
        return state.brand;
    },
    usedRefineSearch(state) {
        return state.usedRefineSearch;
    },
    includeSocialMedia(state) {
        return state.includeSocialMedia;
    },
    telephone(state) {
        return state.telephone;
    },
    showLiveChat(state) {
        return state.showLiveChat;
    },
    headerMenuLinks(state) {
        return state.headerMenuLinks;
    },
    login(state) {
        return state.login;
    },
    accountActions(state) {
        return state.accountVehicleActions
    },
    showSavedVehicleModal(state) {
        return state.showSavedVehicleModal
    }
};

const actions = {
    storeInSession({ state, commit }) {
        console.log('create')
        let url, type, id;
        // Determine if from price alert or saved vehicle
        if (state.savePriceAlertAfterRegister.id !== null && state.savePriceAlertAfterRegister.type !== null) {
            commit('setShowPriceAlertModal', true);  
            url = '/price-alert/store_in_session';
            type = state.savePriceAlertAfterRegister.type;
            id = state.savePriceAlertAfterRegister.id;
        } else {
            url = '/saved-vehicles/store_in_session';
            type = state.saveAfterLoginVehicleData.type;
            id = state.saveAfterLoginVehicleData.id;
        }

        return new Promise((resolve, reject) => {
            axios.post(url, { type, id })
                .then(response => {
                    window.location.href = response.data.redirect_url;
                    resolve(response);
                })
                .catch(e => {
                    console.error(e);
                    reject(e);
                });
        });
    },
    async saveVehicleAfterLogin({ commit, state, dispatch }) {
        commit('setShowSavedVehicleModal', 1)
        dispatch('saveVehicle', state.saveAfterLoginVehicleData);
    },
    initialize({ commit, state, getters, dispatch }, brand) {
        // Don't collect data again if init is done
        if (state.init) {
            return;
        }
        commit('setLoading', true);
        axios.post('/api/layout')
            .then(response => {
                commit('setLoading', false);
                commit('setInit', true);
                commit('setData', response.data);
                commit('setCompare', response.data.compare);
                commit('setSiteLinksNewModels', response.data.siteLinksNewModels);
                commit('setSiteLinksUsedVehicles', response.data.siteLinksUsedVehicles);
            })
            .catch(e => {
                commit('setLoading', false);
            });
    },
    saveVehicle({ commit, state, dispatch }, data) {
        return new Promise((resolve, reject) => {
            let dataType, dataId, dataValue
            if (state.saveAfterLoginVehicleData && state.saveAfterLoginVehicleData.id !== null && !state.admin) {
                dataType = state.saveAfterLoginVehicleData.type
                dataId = state.saveAfterLoginVehicleData.id
                dataValue = state.saveAfterLoginVehicleData.add ? 'true' : 'false';
            } else {
                dataType = data.type
                dataId = data.id
                dataValue = data.add ? 'true' : 'false'
            }

            axios.post('/saved-vehicles/add_remove', {
                type: dataType,
                id: dataId,
                // value is actually just a string flag to add/remove the vehicle
                value: dataValue,
            })
            .then(response => {
                if (!response.data.logged_in) {
                    if (this.hasModule('Auth')) {
                        commit('Auth/setShowLoginModal',{
                            show:true,
                            type:'saved-vehicle',
                        }, { root: true })
                    }
                    commit('setSaveAfterLoginVehicleData', data)
                    resolve(response.data);
                } else {
                    commit('setSaveAfterLoginVehicleData', null)
                    customEvent('Saved Vehicles', 'Used Vehicle Added', 'Added');
                    commit('setCompare', response.data);
                    resolve(response.data);
                    if (dataValue == 'true') {
                        commit('setShowSavedVehicleModal', state.showSavedVehicleModal)
                    }
                }
                dispatch('checkVehicleAccountActions', {vehicleId: dataId, type:'used' });
            })
            .catch(e => {
                console.error(e);
                reject(e);
            });
        });
    },
    getReusableFAQ({ commit, state }, page) {
        return new Promise((resolve, reject) => {
            if (typeof state.reusableFAQs[page] != 'undefined') {
                resolve(state.reusableFAQs[page]);
                return;
            }

            axios.get('/api/reusable-faqs', {
                params: {
                    page: page,
                }
            })
                .then(response => {
                    commit('setReusableFaqPage', {
                        page: page,
                        faq: response.data,
                    });
                    resolve(response.data);
                })
                .catch(e => {
                    console.error(e);
                    reject(e);
                });
        });
    },
    updateNavUserName({ commit }, firstName) {
        commit('setAdminName', firstName);
        commit('setAdmin', true);
    },
    async checkVehicleAccountActions({ commit, state }, { vehicleId, type }) {
        try {
            const response = await axios.post('/api/check-account-actions', { vehicleId, type});
            if (response && response.data) {
                commit('setAccountVehicleActions', response.data );
                if(response.data.displayPriceAlertModal === true){
                    commit('setShowPriceAlertModal', true);  
                }
            } else {
                console.error('Invalid response data:', response);
            }
        } catch (error) {
            console.error('Error fetching account actions:', error);
        }
    },
};
const mutations = {
    setSaveAfterLoginVehicleData(state, data) {
        state.saveAfterLoginVehicleData = data;
    },
    setStatusMessage(state, message) {
        state.statusMessage = message;
    },
    setAdmin(state, admin) {
        state.admin = admin;
    },
    setAdminName(state, adminName) {
        state.adminName = adminName;
    },
    setErrors(state, error) {
        state.errors = error
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setShowSavedVehicleModal(state, display) {
        console.log(display++)
        state.showSavedVehicleModal = display++;
    },
    setCompare(state, compare) {
        let usedCars = (compare.used) ? Object.keys(compare.used) : [];
        let newCars = (compare.new) ? Object.keys(compare.new) : [];
        let motability = (compare.motability) ? Object.keys(compare.motability) : [];
        Vue.set(state.compare, 'used', usedCars);
        Vue.set(state.compare, 'new', newCars);
        Vue.set(state.compare, 'motability', motability);
    },
    setBrand(state, brand) {
        state.brand = brand;
    },
    setAdmin(state, admin) {
        state.admin = admin;
    },
    setAdminName(state, adminName) {
        state.adminName = adminName;
    },
    setInit(state, init) {
        state.init = init;
    },
    setUsedRefineSearch(state, val) {
        state.usedRefineSearch = val;
    },
    setShowSaveCompare(state, val) {
        state.showSaveCompare = val;
    },
    setData(state, data) {
        if (data.headerMenuLinks) {
            state.headerMenuLinks = data.headerMenuLinks;
        }
        if (data.admin) {
            state.admin = true;
            if (data.adminName) {
                state.adminName = data.adminName;
            }
        }
    },
    setReusableFaqPage(state, faqAndPage) {
        Vue.set(state.reusableFAQs, faqAndPage.page, faqAndPage.faq);
    },
    setSiteLinksNewModels(state, data) {
        state.siteLinksNewModels = data;
    },
    setSiteLinksUsedVehicles(state, data) {
        state.siteLinksUsedVehicles = data;
    },
    setAccountVehicleActions(state, actions) {
        state.accountVehicleActions = actions;
    },
    setShowPriceAlertModal(state, display) {
        state.accountVehicleActions.displayPriceAlertModal = display;
    },
    setSavePriceAlertAfterRegister(state, data) {
        state.savePriceAlertAfterRegister = data;
    }
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};




// WEBPACK FOOTER //
// ./resources/assets/js/used-vue/store/modules/layout.js